import React from "react";
import nextId from "react-id-generator";
import { useHistory } from "react-router";
import { checkEmail, signUpAPI, userLogin } from "../../../../APIs/PostAPIS";
import { Images } from "../../../../Assets/0a-exporter";
import { MainContext } from "../../../Dashboard/DashboardContext/Context";
import Notification from "../../../Portals/Notification/Notification";
import "./sign-up-candidate.style.scss";
export default function SignUpCandidate() {
  const history = useHistory();
  const emailRegex = /([\w\.-]+)@([a-z\d-]+)\.([a-z]{2,8})(\.[a-z]{2,8})?/gm;
  const context = React.useContext(MainContext);
  const { initialChecking, updateState } = context;
  const [checking, setChecking] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [exist, setExist] = React.useState(null);
  let timer;
  const [notification, setNotification] = React.useState({
    status: false,
    title: "",
    moreDetails: "",
  });
  const [candidateDetails, setCandidateDetails] = React.useState({
    email: "",
    name: "",
    password: "",
  });

  const clearNotification = async (success) => {
    let res = await userLogin({
      email: candidateDetails.email,
      password: candidateDetails.password,
      role_type: "candidate",
    });
    if (res.data.data) {
      updateState("userDetails", null);
      localStorage.setItem("userId", res.data.data._id);
      localStorage.setItem("iSmartID", res.data.data.iSmartID);
      localStorage.setItem("userEmail", res.data.data.email);
      localStorage.setItem("userToken", res.data.token);
      let a = setTimeout(() => {
        history.push("/register");
        initialChecking();
        clearTimeout(a);
      }, 1000);
    } else {
      setNotification({
        status: true,
        title: `Something went wrong`,
        moreDetails: ``,
      });
    }
    setLoading(false);
  };
  const handleSubmit = async () => {
    try {
      setLoading(true);
      let res = await signUpAPI({
        ...candidateDetails,
        role_type: "candidate",
      });
      if (res.data.statusCode === 200) {
        setNotification({
          status: true,
          title: `Congratulation...!!`,
          moreDetails: `${candidateDetails.name} is registered successfully`,
        });
        clearNotification(true);
      } else {
        setNotification({
          status: true,
          title: `Sorry...!!`,
          moreDetails: `${candidateDetails.name} registration failed`,
        });
        clearNotification(false);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      setNotification({
        status: true,
        title: `Something went wrong`,
        moreDetails: ``,
      });
    }
  };
  const checkForEmail = async () => {
    try {
      setChecking(true);
      let res = await checkEmail({
        email: candidateDetails.email,
        role_type: "candidate",
      });
      if (res.data.data.emailExist) {
        setExist(false);
      } else {
        setExist(true);
      }
      setChecking(false);
    } catch (error) {
      setChecking(false);
    }
  };
  const handleTimer = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      checkForEmail();
    }, 700);
  };
  React.useEffect(() => {
    if (!candidateDetails.email || !emailRegex.test(candidateDetails.email))
      return;
    handleTimer();
  }, [candidateDetails.email]);
  return (
    <div className="sign-up-candidate-wrapper">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
        className="sign-up-candidate-main"
      >
        <Notification
          enabled={notification.status}
          title={notification.title}
          moreDetails={notification.moreDetails}
          closeIt={() =>
            setNotification({
              status: false,
              title: "",
              moreDetails: "",
            })
          }
        />
        <div className="on-border-input">
          <span>Full name*</span>
          <input
            value={candidateDetails.name}
            autoComplete="new-password"
            placeholder="John Silva"
            type="text"
            required
            minLength={5}
            name="name"
            onChange={(e) =>
              setCandidateDetails({
                ...candidateDetails,
                [e.target.name]: e.target.value,
              })
            }
          />
        </div>
        <div
          className={`on-border-input ${
            exist !== null && !exist ? "error" : ""
          }`}
        >
          <span>Email Id*</span>
          <input
            value={candidateDetails.email}
            autoComplete="new-password"
            placeholder="user@gmail.com"
            type="email"
            required
            name="email"
            onChange={(e) => {
              clearTimeout(timer);
              setExist(null);
              setCandidateDetails({
                ...candidateDetails,
                [e.target.name]: e.target.value,
              });
            }}
          />
          {checking ? (
            <p>Checking...</p>
          ) : (
            <p className={exist !== null && !exist ? "" : "d-none"}>
              Email already exist.
            </p>
          )}
        </div>
        <div className="on-border-input">
          <span>Password*</span>
          <div>
            <input
              type={showPassword ? "text" : "password"}
              value={candidateDetails.password}
              autoComplete="new-password"
              placeholder="*********"
              required
              minLength={8}
              name="password"
              onChange={(e) =>
                setCandidateDetails({
                  ...candidateDetails,
                  [e.target.name]: e.target.value,
                })
              }
            />
            {/* <button
              onClick={() => setShowPassword(!showPassword)}
              type="button"
            >
              {showPassword ? (
                <img src="https://img.icons8.com/ios/50/000000/visible--v1.png" />
              ) : (
                <img src="https://img.icons8.com/ios/50/000000/hide.png" />
              )}
            </button> */}
          </div>
        </div>
        <div className="password-wrapper">
          <p>
            <input
              checked={showPassword}
              onChange={(e) => setShowPassword(e.target.checked)}
              type="checkbox"
            />
            Show password
          </p>
        </div>
        <button
          disabled={
            !candidateDetails.email ||
            !candidateDetails.name ||
            !candidateDetails.password ||
            !exist
          }
          type="submit"
          className="sign-up-button"
        >
          {loading ? "Signing Up...." : "Sign Up"}
        </button>
      </form>
      <div className="line-breaker">
        <span />
        <span>Or login with</span>
        <span />
      </div>
      <div className="other-sign-up-option">
        {others.map((obj) => (
          <button key={obj.keyId}>
            <img src={obj.icon} />
          </button>
        ))}
      </div>
    </div>
  );
}

const others = [
  { keyId: nextId(), id: "google", icon: Images.google },
  { keyId: nextId(), id: "fb", icon: Images.facebook },
  { keyId: nextId(), id: "linkedIn", icon: Images.linkedLogo },
];
